// extracted by mini-css-extract-plugin
export default {"divider":"FavoriteDiagnosisAutocompleteControl_divider__dKwJ9"};